import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Input } from "../../components/ui/input";
import { Search } from "lucide-react";
import Pagination from "../components/Pagination";
import { TableSkeleton } from "../components/Skeletons";
import { toast } from "sonner";

const PAGE_SIZE = 20;

export default function LogsPage() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 0, limit: PAGE_SIZE });
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: PAGE_SIZE };
      if (q) params.q = q;
      const res = await api.get("/admin/logs", { params });
      setData(res.data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  }, [page, q]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);
  useEffect(() => { setPage(1); }, [q]);

  return (
    <div className="space-y-6" data-testid="logs-page">
      <div className="flex items-center gap-3">
        <div className="relative flex-1 min-w-[200px] sm:max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            placeholder="Buscar por email…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="pl-9 h-10 rounded-md"
            data-testid="logs-search"
          />
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead>
              <tr className="text-left bg-slate-50 border-b border-slate-200">
                {["Usuário", "Conta consumida", "ID da conta", "Data/Hora"].map((h) => (
                  <th key={h} className="px-5 py-3 text-[11px] uppercase tracking-[0.18em] font-medium text-slate-500">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={4} className="p-0"><TableSkeleton columns={4} rows={6} /></td></tr>
              ) : data.items.length === 0 ? (
                <tr><td colSpan={4} className="px-6 py-14 text-center text-slate-500" data-testid="logs-empty">Sem registros.</td></tr>
              ) : (
                data.items.map((l) => (
                  <tr key={l.id} className="border-b border-slate-100" data-testid={`log-row-${l.id}`}>
                    <td className="px-5 py-3 font-medium text-slate-900 whitespace-nowrap">{l.user_email}</td>
                    <td className="px-5 py-3 text-slate-700 whitespace-nowrap">{l.account_email}</td>
                    <td className="px-5 py-3 mono text-xs text-slate-500">{l.account_id}</td>
                    <td className="px-5 py-3 text-slate-500 text-xs whitespace-nowrap">{new Date(l.timestamp).toLocaleString("pt-BR")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {!loading && data.total > 0 && (
          <Pagination
            page={data.page}
            pages={data.pages}
            total={data.total}
            limit={data.limit}
            onChange={setPage}
          />
        )}
      </div>
    </div>
  );
}
